<script setup>
defineProps({
  embedUrl: {
    type: String,
    required: true,
  },
  chatUrl: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: 'Livestream',
  },
});
</script>

<template>
  <div class="vimeo-livestream-player">
    <iframe
      class="vimeo-livestream-player__video"
      :src="embedUrl"
      :title="`${title} livestream video`"
      allow="autoplay; fullscreen; picture-in-picture"
      allowfullscreen
      loading="lazy"
    ></iframe>

    <iframe
      v-if="chatUrl"
      class="vimeo-livestream-player__chat"
      :src="chatUrl"
      :title="`${title} livestream chat`"
      loading="lazy"
    ></iframe>
  </div>
</template>
